"use client";

import { UseFormReturnType } from "@mantine/form";
import type { Form } from "@bi-studio/shared/lib";

interface FormDisplayProps {
    form: Form;
    mantineForm: UseFormReturnType<any>;
    submitting: boolean;
    onSubmit: (values: any) => Promise<void>;
    handleValidationError: () => void;
}

import { StandardFormDisplay } from './displays/StandardFormDisplay';

export function FormDisplay({
    form,
    mantineForm,
    submitting,
    onSubmit,
    handleValidationError,
}: FormDisplayProps) {
    const isFormIncomplete = form.fields.some(field =>
        field.required && (
            mantineForm.values[field.name] === undefined ||
            mantineForm.values[field.name] === null ||
            mantineForm.values[field.name] === '' ||
            (field.type === 'checkbox' && mantineForm.values[field.name] === false) ||
            (field.type === 'multiselect' && Array.isArray(mantineForm.values[field.name]) && mantineForm.values[field.name].length === 0)
        )
    );

    const sortedFields = [...form.fields].sort((a, b) => a.order - b.order);

    return (
        <StandardFormDisplay
            form={form}
            mantineForm={mantineForm}
            sortedFields={sortedFields}
            isFormIncomplete={isFormIncomplete}
            submitting={submitting}
            onSubmit={onSubmit}
            handleValidationError={handleValidationError}
        />
    );
}
